import { render } from "./backgroundImage.vue?vue&type=template&id=ac10a50c&scoped=true&ts=true"
import script from "./backgroundImage.vue?vue&type=script&lang=ts"
export * from "./backgroundImage.vue?vue&type=script&lang=ts"

import "./backgroundImage.vue?vue&type=style&index=0&id=ac10a50c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac10a50c"]])

export default __exports__